export default __webpack_public_path__ + "static/media/background.961abdbe.jpg";